import { SharedModule } from "../../../../shared/shared.module";
import { NgModule } from "@angular/core";
import { PricesTableLicenseItemComponent } from "./prices-table-license-item.component";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskModule } from "ngx-mask";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [PricesTableLicenseItemComponent],
  declarations: [PricesTableLicenseItemComponent],
})
export class PricesTableLicenseItemModule {}
